import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=3ff04b28&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=3ff04b28&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff04b28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ff04b28')) {
      api.createRecord('3ff04b28', component.options)
    } else {
      api.reload('3ff04b28', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=3ff04b28&scoped=true", function () {
      api.rerender('3ff04b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/visit-registration-calendar/Main.vue"
export default component.exports